export const authenticationApis = {
    login: 'v1/api/auth/login',
    ssoLogin: 'v1/api/auth/getProfile',
    logout: 'v1/api/auth/logout',
    forgotPassword: 'v1/api/auth/forgotPassword',
    resetPassword: 'v1/api/auth/resetPassword',
    decodeForgotPasswordToken: 'v1/api/auth/decode',
    getScanner: 'v1/api/auth/2fa/scanner',
    getVerification: 'v1/api/auth/2fa/verify',
    checkPassword: 'v1/api/auth/checkPassword',
    switchLogin: 'v1/api/auth/switchLogin',
    getAccessToken: 'v1/api/auth/refreshWebToken'
};
